import { IGroupApexChart } from 'models/IGroup'

type IFoodStateChart = {
	eatenChartData: IGroupApexChart[]
	daysBetweenDates: number
	layerd_graph?: Array<{ start: number; end: number }>
}

export const calculateChartFoodState = ({
	eatenChartData,
	layerd_graph,
}: IFoodStateChart) => {
	const dataAvailable = eatenChartData.map(el =>
		el.status === 'success' ? el.r_feed : null,
	)
	const dataUnavailable = eatenChartData.map(el =>
		el.status === 'success' ? el.ur_feed : null,
	)
	const dataCameraIssue: Array<number | null> = eatenChartData.map(() => null)
	const dataXasis = eatenChartData.map(el => new Date(el.start_dt).getTime())
	const densityList = eatenChartData.map(el => el.density)
	const layeredValues = []

	const getTotalFeed = (index: number) => {
		const item = eatenChartData[index]
		if (typeof item?.r_feed !== 'number' || typeof item?.ur_feed !== 'number')
			return null

		return item.r_feed + item.ur_feed
	}

	let index = 0
	while (index < eatenChartData.length) {
		if (eatenChartData[index].status !== 'camera_issue') {
			index += 1
			continue
		}

		const issueStart = index
		while (
			index + 1 < eatenChartData.length &&
			eatenChartData[index + 1].status === 'camera_issue'
		)
			index += 1
		const issueEnd = index
		const previousSuccess =
			eatenChartData[issueStart - 1]?.status === 'success'
				? issueStart - 1
				: null
		const nextSuccess =
			eatenChartData[issueEnd + 1]?.status === 'success' ? issueEnd + 1 : null
		const previousTotal =
			previousSuccess === null ? null : getTotalFeed(previousSuccess)
		const nextTotal = nextSuccess === null ? null : getTotalFeed(nextSuccess)

		if (previousSuccess !== null) dataCameraIssue[previousSuccess] = 0

		for (let issueIndex = issueStart; issueIndex <= issueEnd; issueIndex += 1) {
			if (previousTotal !== null && nextTotal !== null) {
				const previousTimestamp = eatenChartData[issueStart - 1].start_dt
				const nextTimestamp = eatenChartData[issueEnd + 1].start_dt
				const currentTimestamp = eatenChartData[issueIndex].start_dt
				const interval = nextTimestamp - previousTimestamp
				dataCameraIssue[issueIndex] =
					interval > 0
						? previousTotal +
							((currentTimestamp - previousTimestamp) *
								(nextTotal - previousTotal)) /
								interval
						: previousTotal
			} else {
				dataCameraIssue[issueIndex] = previousTotal ?? nextTotal
			}
		}

		if (nextSuccess !== null) dataCameraIssue[nextSuccess] = 0
		index += 1
	}
	if (layerd_graph) {
		dataXasis.forEach(el => {
			const timestamp = new Date(el).getTime()
			const isInInterval = layerd_graph.some(interval => {
				return timestamp >= interval.start && timestamp <= interval.end
			})

			if (isInInterval) {
				layeredValues.push(0)
			} else {
				layeredValues.push(null)
			}
		})
	}
	return {
		dataAvailable,
		dataUnavailable,
		dataCameraIssue,
		dataXasis,
		densityList,
		layeredValues,
	}
}
